import React, { useState } from "react";
import { publishBrand, unPublishBrand } from "../../../services/brandService";
import Swal from "sweetalert2";
import { handleErrors } from "../../../utils/errorHandler";

const BrandToggleSwitch = ({ propId, initialStatus, onStatusChange }) => {
  const [isPublished, setisPublished] = useState(initialStatus === "Published");

  const handleToggle = async () => {
    const newStatus = isPublished ? "UnPublish" : "Publish";
    const modalTitle = isPublished ? "UnPublish Brand" : "Publish Brand";
    const modalMessage = isPublished
      ? "Are you sure you want to unPublish this brand?"
      : "Are you sure you want to publish this brand?";

    const result = await Swal.fire({
      title: modalTitle,
      text: modalMessage,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes",
      cancelButtonText: "Cancel",
    });

    if (result.isConfirmed) {
      try {
        if (isPublished) {
          await unPublishBrand(propId, newStatus);
        } else {
          await publishBrand(propId, newStatus);
        }
        setisPublished(!isPublished);
        onStatusChange(newStatus);

        Swal.fire(
          "Success!",
          `The brand has been ${
            newStatus === "Publish" ? "Published" : "UnPublished"
          }.`,
          "success"
        );
      } catch (error) {
        handleErrors(error);
      }
    }
  };

  return (
    <label className="switch">
      <div className="form-check form-switch form-switch-custom form-switch-primary">
        <input
          className="form-check-input"
          type="checkbox"
          checked={isPublished} // Checked means user is Blocked
          onChange={handleToggle}
        />
      </div>
      <span className="slider round"></span>
    </label>
  );
};

export default BrandToggleSwitch;
